import { BadgeWithDot } from "@/components/ui/badge"

type StatusColor = "gray" | "blue" | "indigo" | "success" | "error"

// The warm-start funnel statuses, mapped to badge colours. Shared by the admin
// ledger and the dashboard growth band so the two surfaces stay in lockstep.
const STATUS_COLORS: Record<string, StatusColor> = {
  created: "gray",
  sent: "blue",
  opened: "blue",
  claimed: "indigo",
  published: "success",
  bounced: "error",
  revoked: "gray",
  expired: "gray",
}

export function WarmStartStatusBadge({ status }: { status: string }) {
  return (
    <BadgeWithDot
      color={STATUS_COLORS[status] ?? "gray"}
      size="sm"
      type="modern"
      className="capitalize"
    >
      {status}
    </BadgeWithDot>
  )
}
